import React, { useCallback } from 'react';
import * as LucideIcons from 'lucide-react';
import { httpsCallable } from 'firebase/functions';
import { useTranslation } from 'react-i18next';

import { useAppContext } from '../AppContext';

const PayoutSetupModal = ({ onClose }) => {
    const { t } = useTranslation();
    const { user, userId, setMessage, appFunctions } = useAppContext();
    const handleStripeConnectOnboarding = useCallback(async () => {
        if (!user || !userId || !appFunctions) {
            setMessage(t('payoutSetupModal.signInRequired'));
            return;
        }
        try {
            const createAccountLink = httpsCallable(appFunctions, 'createStripeConnectAccountLink');
            const result = await createAccountLink({
                returnUrl: window.location.origin + '?page=walletHub',
                refreshUrl: window.location.origin + '?page=walletHub',
            });
            const { url, error } = result.data;
            if (url) {
                window.location.href = url;
            } else {
                setMessage(`${t('payoutSetupModal.stripeError')}: ${error || t('payoutSetupModal.unknownError')}`);
            }
        } catch (e) {
            console.error("Error calling createStripeConnectAccountLink:", e);
            setMessage(`${t('payoutSetupModal.setupError')}: ${e.message}`);
        }
    }, [user, userId, setMessage, appFunctions, t]);

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center p-4" style={{ zIndex: 'var(--z-index-modal-backdrop)' }}>
            <div className="bg-gray-800 bg-opacity-90 p-6 rounded-lg shadow-xl max-w-md w-full text-white relative">
                <h3 className="text-xl font-bold mb-4 text-blue-300 font-playfair">{t('payoutSetupModal.title')}</h3>
                <p className="text-lg mb-6 leading-relaxed">{t('payoutSetupModal.description')}</p>
                <div className="flex justify-center space-x-4">
                    <button onClick={handleStripeConnectOnboarding} className="px-6 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition duration-300">{t('payoutSetupModal.connectButton')}</button>
                    <button onClick={onClose} className="px-6 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition duration-300">{t('payoutSetupModal.notNowButton')}</button>
                </div>
                <button onClick={onClose} className="absolute top-3 right-3 p-2 rounded-full bg-gray-700 hover:bg-gray-600 text-white transition duration-300" aria-label={t('payoutSetupModal.closeAriaLabel')}><LucideIcons.X size={20} /></button>
            </div>
        </div>
    );
};

export default PayoutSetupModal;
